export default {
  customized: 'Prispôsobený',
  noMatches: 'Nenašli sa žiadne komponenty',
};
